import React, {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';
import {Alert, Button, Col, Layout, Row} from 'antd';
import {IconSpin} from "../../icons/icons";
import {doAuth, storeToLocalStorage} from "../../tools/Tools";
import MFACodeInput from "../../components/MFACodeInput";
import Redirector from "../../tools/Redirector";
import {AppConfig} from "../../Config";
import styles from "../authCallback/components/DPAForm.module.scss";
import Loading from "../Loading";

const baseUrl = Redirector.getUri();
const url: URL = new URL(window.location.href);
const code: string | null = url.searchParams.get('code');
const token = localStorage.getItem("token");
const GoogleSignIn = () => {

	const [authenticated, setAuthenticated] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [showMfa, setShowMfa] = useState<boolean>(false);
	const [mfaError, setMfaError] = useState(false);
	const [idToken, setIdToken] = useState<string | null>(null);
	const [mfaCode, setMfaCode] = useState<string | null>(null)
	const makeAuthRequest = (code: string | null) => {

		if (code) {
			setError(null);
			let request: any;
			if(idToken === null) {
				request = {
					"code": code,
					"google-signin": true
				};
			} else if(mfaCode !== null) {
				request = {
					'id_token' : idToken,
					'mfa_code' : mfaCode
				};
			}
			doAuth(request)
				.then((res: any) => {
					if (res && res.token) {
						storeToLocalStorage('token', res.token);
						setAuthenticated(true);
					}
				})
				.catch(err => {
					setError(err.message);
					switch (err.code) {
						case "A403":
							setError(err.message);
							setShowMfa(false);
							break;
						case "M403":
							setError(null);
							!showMfa && setShowMfa(true);
							setIdToken(err.additional.id_token);
							break;
						case "M404":
						case "M405":
							setError(err.message);
							setShowMfa(true);
							setMfaError(true);
							break;
						case "GL403":
							setError(err.message);
							setIdToken(null);
							break;
						default:
							setError(err.message);
							break;
					}
				});
		}
	};

	console.log(AppConfig.getGoogleAuthUrl());
	useEffect(() => {
		if(code) {
			makeAuthRequest(code);
		} else if(token) {
			setAuthenticated(true);
		}
	}, []);

	if(authenticated) {
		return <Navigate to={baseUrl}/>;
	}

	if(!authenticated && !token && !code && !error)
	{
		return <Navigate to={"/"}/>;
	}

	if(!authenticated && !error && !showMfa) {
		return <Loading col={5} title={"Please wait"} showLogo={true}/>
	}

	return (
		<Layout className={styles.dpaForm}>
			<Row align={"top"} justify={"center"} style={{
				minHeight: '100vh',
				height: '100vh',
				alignItems: 'stretch',
				overflow: 'auto',
			}}>
				<Col lg={12} xl={9} md={12} sm={20} xs={24}>
					<Row style={{alignItems: "center", height: "100%", justifyContent: "center"}}>
						<Col lg={16}>
							{error && !showMfa &&
                                <div>
                                    <div className={styles.logo}>
                                        <IconSpin style={{fontSize: 140}}/>
                                    </div>
                                    <Alert message={error} type={"error"} style={{marginBottom: '24px'}} action={
										<Button onClick={() => window.location.href = "/"}>
											Continue to Login
										</Button>
									}/>
                                </div>
							}
							{showMfa &&
								<div style={{textAlign: "center"}}>
									<div className={styles.logo}>
										<IconSpin style={{fontSize: 140}}/>
									</div>
									<MFACodeInput
										title={<h3 style={{textAlign: "center"}}>MFA Required</h3>}
										numInputs={6}
										description={"Enter 6 digit code from your app"}
										hasError={mfaError}
										errorMessage={error}
										onChange={(val) => {
											setMfaError(false);
											setError(null);
											setMfaCode(val);
										}}
									/>
									<Button type="primary" onClick={() => makeAuthRequest(code)}
									        size={"large"} style={{marginTop: 15}}>
										Continue
									</Button>
								</div>
							}
						</Col>
					</Row>
				</Col>
			</Row>
		</Layout>
	);
};

export default GoogleSignIn;